import { produce } from "immer";
import { CatalogAction, GET_CATEGORIES } from "./catalog.actions";
import CatalogRootState from "../models/catalog-redux-state.interface";

const initialState: CatalogRootState = {
    categories: undefined,
    product: undefined
};

export default (catalogState = initialState, action: CatalogAction): CatalogRootState => produce(catalogState, draft => {
    switch (action.type) {
        case GET_CATEGORIES: {
            draft.categories = action.categories;
            break;
        }
    }
});
